module.exports = __webpack_public_path__ + "static/media/Java.908bcbe9.png";